/* eslint-disable vue/no-use-v-if-with-v-for */
/* eslint-disable vue/valid-v-for */
<template>
  <div class="container">
    <div class="radio_box">
      <div v-for="data in datas" :key="data.groupType">
        <div class="radio_title_box">
          <img :src="require('../assets/images/ask.png')" class="ask-icon" />
          <p class="radio_title">
            {{ data.groupName }}
          </p>
        </div>
        <div class="radio_list">
          <template v-for="result in data.satisfactionList">
            <radioGroup v-if="result.answerType === 1" :id="result.id" :key="result.id" :title="result.qsContent"
              :list="result.answerContentList" :answer-code="result.answerCode" :on-change="selectChange" />
            <template v-for="item in result.childList">
              <radioGroup v-if="result.answerCode === 'YES'" :id="item.id" :key="item.id" class="radio_child"
                :title="item.qsContent" :list="item.answerContentList" :answer-code="item.answerCode"
                :on-change="selectChange" />
            </template>
          </template>
        </div>
      </div>
    </div>
    <!-- 怎么改进我们的服务 两个输入框 -->
    <div class="nurse_remark">
      <div class="tips-wrap">
        <img :src="require('../assets/images/ask.png')" class="ask-icon" />
        <p class="tips">
          {{ $t('improveTheService') }}
        </p>
      </div>
      <div class="input-wrap">
         <div class="textarea-wrapper">
           <textarea v-model.trim="params.advice" maxlength="300" class="textarea"
           :placeholder="$t('suggestionsForImprovement')" />
           <div class="char-count">
            {{ params.advice ? params.advice.length : 0 }}/300
          </div>
         </div>
          <textarea v-model.trim="params.nurseName" maxlength="30" class="input" :placeholder="$t('nursingName')" />
      </div>
    </div>
    <!-- 怎么改进我们的服务 两个输入框 end-->
    <div class="nurse_tn_box">
      <button @click="submit">
        {{ $t('submit') }}
      </button>
    </div>
  </div>
</template>

<script>
import APIS from '../helpers/APIS'
import { axPost } from '../helpers'
import { NURSINGGROUP } from '../helpers/CONSTANTS'
import radioGroup from './RadioGroup'

export default {
  name: 'Index',
  components: { radioGroup },
  // eslint-disable-next-line vue/require-prop-types
  props: {
    satisfactionSource: {
      type: String,
      default: ''
    },
    questionnaire: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      params: {
        episodeCode: '',
        nurseName: '',
        advice: '',
        submitFinishStatus: 1, // 提交状态最终提交 1
        satisfactionList: []
      },
      picked: '',
      checkFlag: true,
      datas: [],
      isSubmitting: false
    }
  },
  watch: {
    questionnaire: {
      handler: function () {
        if (!this.questionnaire.groupSatisfactionList) return
        this.datas = this.questionnaire.groupSatisfactionList.filter((item) => {
          return (
            item.groupType === NURSINGGROUP.BASICSERVICES ||
            item.groupType === NURSINGGROUP.PAINMANAGEMENT
          );
        });
      },
      immediate: true
    }
  },
  methods: {
    selectChange (answerCode, id) {
      this.datasFor((answerContent, i, j) => {
        if (answerContent.id === id) {
          this.datas[i].satisfactionList[j].answerCode = answerCode
        }
        if (answerContent.childList) {
          answerContent.childList.forEach(item => {
            if (item.id === id) item.answerCode = answerCode
            if (answerContent.answerCode === 'NO') {
              item.answerCode = ''
            }
          });
        }
      })
    },
    datasFor (cb) {
      const dataLen = this.datas.length
      for (let i = 0; i < dataLen; i++) {
        const satisfactionList = this.datas[i].satisfactionList
        const satisfactionLen = satisfactionList.length
        for (let j = 0; j < satisfactionLen; j++) {
          const answerContent = satisfactionList[j]
          cb(answerContent, i, j)
        }
      }
    },
    listPush (data) {
      let pushFlag = true
      this.params.satisfactionList.forEach(item => {
        if (item.id === data.id) {
          item.id = data.id
          item.answerCode = data.answerCode
          pushFlag = false
        }
      })
      if (pushFlag) {
        this.params.satisfactionList.push(data)
      }
    },
    async submit() { // 提交
      if (this.isSubmitting || !this.datas || this.datas.length === 0) {
        return;
      }
      this.isSubmitting = true;
      this.params.episodeCode = this.questionnaire.episodeCode
      this.params.satisfactionSource = this.satisfactionSource
      this.params.satisfactionList = []

      // 检查是否有题目未作答
      let isRespondence = true;
      this.datasFor((answerContent, i, j) => {
        if (!answerContent.answerCode) {
          isRespondence = false
          return
        }
        this.listPush(
          {
            id: answerContent.id,
            answerCode: answerContent.answerCode
          }
        )
        if (answerContent.childList) {
          for (let i = 0; i < answerContent.childList.length; i++) {
            if (!answerContent.childList[i].answerCode && answerContent.answerCode === 'YES') {
              isRespondence = false
              return
            }
            if (answerContent.childList[i].answerCode) {
              this.listPush(
                {
                  id: answerContent.childList[i].id,
                  answerCode: answerContent.childList[i].answerCode
                }
              )
            }
          }
        }
      })
      if (!isRespondence) {
        alert(this.$t('errSolution'))
        this.isSubmitting = false
        return
      }

      let temp = JSON.parse(JSON.stringify(this.params));
      temp.satisfactionList = JSON.stringify(temp.satisfactionList)
      
      temp.callback = this.$route.query.callback
      try {
        const { data: { msg, code, data } } = await axPost(APIS.SUBMIT, temp);
        if (code === 0) {
          this.$emit('JumpMode', data)
        } else {
          alert(msg)
          this.isSubmitting = false
        }
      } catch (e) {
        this.isSubmitting = false
        //
      }
    }
  }
}
</script>

<style lang="less">
  .details_top{
    background: #fff;
    box-sizing: border-box;
    width: 100%;
    // height: 260px;
    line-height: 42px;
    font-size: 28px;
    color: rgba(28,2,2,0.5);
    padding: 30px 30px;
    padding-top: 18px;
    text-indent: 55px;
  }
  .nurse_remark{
    background: #fff;
    padding: 0 30px;
    margin-top: 30px;
    .tips-wrap{
      height: 97px;
      background: #EEF1F4;
      border-radius: 20px 20px 0px 0px;
      display: flex;
      align-items: center;
      padding: 0px 30px;
      .tips{
        font-weight: 500;
        font-size: 30px;
        color: #48C9EF;
      }
    }
    .input-wrap{
      padding: 20px 30px;
      background: #F6F8FB;
      .textarea-wrapper {
        position: relative;
        .char-count {
          position: absolute;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #C6CDD2;
          right: 10px;
          bottom: 20px;
          pointer-events: none;
          background: #fff;
          padding: 5px 10px;
          border-radius: 4px;
        }
      }
    }
    .textarea{
      text-align: left;
      font-size: 30px;
      padding: 24px;
      height: 180px;
      width: 100%;
      resize: none;
      box-sizing: border-box;
      -webkit-appearance: none;
      color: #000;
      font-weight: 500;
      border-radius: 14px;
      
      &::-webkit-input-placeholder {
        /* WebKit browsers */
        font-weight: 400;
        font-size: 28px;
        color: #C6CDD2;
      }
    }
    .input{
      width: 100%;
      min-height: 80px;
      font-size: 30px;
      resize: none;
      box-sizing: border-box;
      -webkit-appearance: none;
      padding: 24px;
      margin-top: 24px;
      color: rgb(128, 128, 128);
      border-radius: 14px;
      text-align: left;
      font-weight: 500;
            
      &::-webkit-input-placeholder {
        /* WebKit browsers */
        font-weight: 400;
        font-size: 28px;
        color: #C6CDD2;
      }
    }
  }
  .nurse_tn_box{
    background: #fff;
    text-align: center;
    padding:40px 0 calc(42px + env(safe-area-inset-bottom));
    button{
      width: 690px;
      height: 90px;
      background: linear-gradient( 135deg, #7BECD3 0%, #45D4A8 100%);
      border-radius: 45px;
      outline: none;
      border: none;
      font-size: 32px;
      text-align: center;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .radio_box{
    background: #fff;
    padding: 0 30px;
    .radio_title_box {
      background: #EEF1F4;
      border-radius: 20px 20px 0px 0px;
      display: flex;
      align-items: center;
      padding: 0 30px;
      height: 97px;
    }
    .radio_list{
      background: #F6F8FB;
      padding: 0 30px;
      margin-bottom: 30px;
    }
    .radio_title{
      font-weight: 500;
      font-size: 30px;
      color: #48C9EF;
    }
  }
   .ask-icon{
      width: 40px;
      height: 32px;
      margin-right: 10px;
    }
</style>
